/**
 * wireAbilityCastDebug — Agent smoke hooks for QWER live cast (AB-11).
 */
export function wireAbilityCastDebug(abilityCast, globalObj = globalThis) {
  if (!abilityCast || typeof globalObj === 'undefined') return null;

  function cast(slot) {
    const key = String(slot || '').toUpperCase();
    if (key === 'Q' && abilityCast.onActivateQ) {
      abilityCast.onActivateQ();
      return { ok: true, slot: 'Q' };
    }
    if (key === 'W' && abilityCast.onCastW) {
      abilityCast.onCastW();
      return { ok: true, slot: 'W' };
    }
    if (key === 'E' && abilityCast.onCastE) {
      abilityCast.onCastE();
      return { ok: true, slot: 'E' };
    }
    if (key === 'R' && abilityCast.onCastR) {
      abilityCast.onCastR();
      return { ok: true, slot: 'R' };
    }
    return { ok: false, reason: 'INVALID_SLOT' };
  }

  function castKit() {
    return ['Q', 'W', 'E', 'R'].map((slot) => cast(slot));
  }

  globalObj.__debugCastAbility = cast;
  globalObj.__debugCastKit = castKit;

  return { cast, castKit };
}
